define(['jquery', 'erv_checks', 'erv_autosuggest'], function ($, ERVChecks, ERVAutosuggest) {

	var ResponsiveDeviceMenu = function ($header) {
		var self = this;
		self.checks = new ERVChecks();
		self.$menuTrigger = $header.find('#device-menu-trigger');
		self.$menu = $header.find('#device-menu');

        self.addEventListener = function () {
			self.$menuTrigger.on('click touch', function (e) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				$('body').toggleClass('device-menu-open');
				if (!$('body').hasClass('device-menu-open')) {
                    ERVAutosuggest.default.clearSuggestionsContainer();
                }
				if (self.checks.isIos() && !$('body').hasClass('device-menu-open')) {
					setTimeout(function () {
						var fixedElement = $('header .home')[0], 
							disp = fixedElement.style.display;

						fixedElement.style.display = 'none';
						fixedElement.style.display = disp;
					}, 305);
				}
			});

			$('body').on('click touch', function (e) {
				if ($(this).hasClass('device-menu-open')) {
					var targetId = $(e.target).attr('id');
					if (!$.contains($('#device-menu-container')[0], e.target) && targetId !== 'device-menu-container' &&
						targetId !== 'main-search-input' && targetId !== 'main-search-button') {
						$(this).trigger('ervCloseDeviceMenu');
					}
				}
			});

			$('body').on('ervCloseDeviceMenu', function () {
				self.$menuTrigger.click();
			});

			self.$menu.find('a.active').each(function () {
				var $linkList = $(this).parents('.link-list');
				if ($linkList.find('ul li').length > 1) {
					$linkList.addClass('is-expanded');
				} else {
					$linkList.find('h3').addClass('bold');
				}
			});
		}

		self.removeEventListener = function () {
			$('body').removeClass('device-menu-open');
			self.$menuTrigger.unbind();
			$('body').unbind('ervCloseDeviceMenu');
		}
	};

	ResponsiveDeviceMenu.prototype.initSmallerDevice = function () {
		var self = this;
		self.removeEventListener();
		self.addEventListener();
	}

	ResponsiveDeviceMenu.prototype.initLargeDevice = function () {
		var self = this;
		self.removeEventListener();
	}

	return ResponsiveDeviceMenu;
});